<div class="flex flex-wrap mt-8 mb-6">

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        <div class="flex gap-2 justify-center">
            @if (activeTab === 'awards' && ((myRoles$ | async)?.management || user?.uid === grade?.teacherId))
            {
            <app-btn-action label="New Certificate" (clicked)="onNewAward()" bgColor="bg-primary-500"
                textColor="text-white" icon="fa fa-add"></app-btn-action>
            }
            @if ((myRoles$ | async)?.parents && student?.parentId == user?.uid && student?.unregistered && activeTab === 'overview') {
            <app-btn-route routeTo="profile" [returnParams]="{'activeTab': 'overview'}"
                colors="bg-primary-500 hover:bg-primary-300" textColor="text-white" icon="fa fa-edit"
                btnText="Edit Profile"></app-btn-route>
            }
        </div>
    </div>

    <div class="mb-2 border-0 w-full">
        <h1 class="font-semibold text-2xl text-primary-500">
            {{ student?.name }}'s Space
        </h1>
    </div>


    <div class="w-full">
        <!-- Tabs Navigation -->
        <div class="border-b border-gray-200">
            <nav class="flex space-x-4">
                <button (click)="setActiveTab('lessons')"
                    [class]="activeTab === 'lessons' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Lessons
                </button>
                <button (click)="setActiveTab('assignments')"
                    [class]="activeTab === 'assignments' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Assignments
                </button>
                <button (click)="setActiveTab('awards')"
                    [class]="activeTab === 'awards' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Certificates
                </button>
                <!-- <button (click)="setActiveTab('attendance')"
                    [class]="activeTab === 'attendance' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Attendance
                </button> -->
                <button (click)="setActiveTab('overview')"
                    [class]="activeTab === 'overview' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Overview
                </button>
            </nav>
        </div>

        <!-- Tab Content -->
        <div class="mt-6">
            @if(activeTab === 'lessons') {
            <div class="rounded-t block w-full overflow-x-auto shadow-lg rounded bg-white">
                <table class="items-center w-full bg-transparent text-sm border-collapse">
                    <thead class="w-full">
                        <tr>
                            @for (item of lessonsHeader; track item) {
                            <th
                                class="px-6 align-middle border-0 border-solid py-3 uppercase whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                                {{item}}
                            </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @let loadingLessons = (loadingLessons$ | async);
                        @for (item of lessons; track $index) {
                        <tr>
                            <td [routerLink]="['lessons', item.id]"
                                class="cursor-pointer border-t-0 px-6 py-4 align-middle py-auto border-l-0 border-r-0 whitespace-nowrap">
                                <div class="flex flex-col gap-2">
                                    <p class="text-sm font-semibold ">{{ item.lessonName }}</p>
                                </div>
                            </td>
                            <td
                                class="cursor-default border-t-0 px-6 py-2 align-middle text-sm border-l-0 border-r-0 whitespace-nowrap">
                                {{ item.publishBy | moment: 'Do MMM YYYY' }}
                            </td>
                        </tr>
                        } @empty {
                        @if (!loadingLessons) {
                        <tr>
                            <td [colSpan]="lessonsHeader.length"
                                class="px-6 py-4 text-sm text-center font-semibold border-0 whitespace-nowrap">
                                No data available
                            </td>
                        </tr>
                        }
                        }
                        @if (loadingLessons) {
                        <tr>
                            @for (item of lessonsHeader; track item) {
                            <td class="px-6">
                                <div class="animate-pulse h-4 w-full pr-8 bg-slate-200 rounded my-4"></div>
                            </td>
                            }
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div class="flex flex-row w-full justify-center px-4 mt-3">
                <app-btn-more (click)="addMoreLessons()"
                    [isDisabled]="(loadingLessons$ | async) || studentId == null || groupId == null"></app-btn-more>
            </div>
            } @else if (activeTab === 'assignments') {
            <app-list-assignments></app-list-assignments>
            } @else if (activeTab === 'awards') {
            <app-list-awards [studentId]="studentId" [groupId]="groupId" [fetchAllGroups]="isStudentOrParent" [showGroupName]="isStudentOrParent"></app-list-awards>
            } @else if (activeTab === 'overview') {

            <div class="w-full overflow-x-auto mt-4 flex flex-row justify-between shadow-lg rounded bg-white p-4">
                <div class="flex flex-col">
                    <div class="w-full mb-1">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold">
                            Grade
                        </label>
                        <span class="text-blueGray-600 text-sm">{{grade?.gradeName}}</span>
                    </div>
                    <div class="w-full mt-4">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold">
                            Teacher
                        </label>
                        <span class="text-blueGray-600 text-sm">{{grade?.teacherName ?? 'Unassigned'}}</span>
                    </div>
                </div>
                <div class="flex flex-col justify-end">
                    <span class="text-blueGray-600 text-6xl font-bold inline text-right">{{
                        attendanceStats?.present ??
                        '-'}}/{{ attendanceStats ? attendanceRecords(attendanceStats) :
                        '-'}}</span>
                    <span class="text-blueGray-400 text-sm text-right">Attendance Status</span>
                </div>

            </div>

            <div class="block w-full overflow-x-auto mt-4 shadow-lg rounded bg-white p-4">
                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Student Name
                    </label>
                    <span class="text-blueGray-600 text-sm">{{student?.name}}</span>
                </div>
                <div class="w-full mt-4">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Parent Name
                    </label>
                    <span class="text-blueGray-600 text-sm">{{student?.parentName}}</span>
                </div>
                <div class="w-full mt-4">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Gender
                    </label>
                    <span class="text-blueGray-600 text-sm">{{student?.gender ?? 'Not Specified'}}</span>
                </div>
                <div class="w-full mt-4">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Registration Status
                    </label>
                    <span class="text-blueGray-600 text-sm">{{ student?.unregistered == undefined ||
                        !student?.unregistered ?
                        'Registered' : 'Unregistered' }}</span>
                </div>
            </div>
            }
        </div>
    </div>
</div>